import React from 'react';
import classNames from 'classnames/bind';
import { node, string } from 'prop-types';
import { RenderResolver } from './RenderResolver';
import styles from '../navigational-layout.scss';

/**
 * This component is a shorthand for the RenderResolver component. It is specifically for the navigational layout.
 *
 * @param {string} componentId - The unique identifier for the child component.
 * @param {node} children - The children components.
 * @returns {JSX.Element} The rendered component.
 */
export const NavigationalRenderResolver = ({ children, componentId }) => {
  const cx = classNames.bind(styles);

  return (
    <RenderResolver componentId={componentId} key={componentId} pageType="navigationalLayout" templateSectionStyle={cx('navigational-layout__static-section')}>
      {children}
    </RenderResolver>
  );
};

NavigationalRenderResolver.propTypes = {
  children: node,
  componentId: string.isRequired,
};

NavigationalRenderResolver.defaultProps = {
  children: null,
};
